import React from 'react';
import VehicleRow from './VehicleRow';
import FilterableTable from '../filters/FilterableTable';

const VehicleTable = ({
  dispatch,
  vehicleReducer,
  findAllVehiclePageble,
  updateVehicle,
  deleteVehicle,
  clearValidationErrors,
  brandReducer
}) => {
  const { vehicleList, totalElements } = vehicleReducer;

  let vehicleNameList = vehicleList.map((vehicle, index) => (
    <VehicleRow
      key={vehicle.id}
      vehicle={vehicle}
      deleteVehicle={deleteVehicle}
      updateVehicle={updateVehicle}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      vehicleReducer={vehicleReducer}
      brandReducer={brandReducer}
    />
  ));

  const columns = [
    {
      id: 'Vozilo',
      name: 'Vozilo',
      filter: {
        field: 'vehicleName',
        value: '',
        type: 'LIKE',
      },
    },
    {
      id: 'Brend',
      name: 'Brend',
      filter: {
        field: 'brand.brandName',
        value: '',
        type: 'CHILD_LIKE',
      },
    },
    {
      id: 'Model',
      name: 'Model',
      filter: {
        field: 'vehicleModel.modelName',
        value: '',
        type: 'CHILD_LIKE',
      },
    },
    {
      id: 'Registarski broj',
      name: 'Registarski broj',
      filter: {
        field: 'licensePlateNumber',
        value: '',
        type: 'LIKE',
      },
    },
    {
      id: 'Vozač',
      name: 'Vozač',
      filter: {
        field: 'driver.username',
        value: '',
        type: 'CHILD_LIKE',
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },

  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllVehiclePageble}
        rows={vehicleNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default VehicleTable;
